export type SupportedBrand = 'EY' | 'ES' | 'HP' | 'OL';

export const EYIconNames = [
  'breakfast',
  'fitness',
  'grill',
  'kitchen',
  'laundry',
  'pet-friendly',
  'studio',
] as const;

export const ESIconNames = [
  'breakfast',
  'drink',
  'fitness',
  'breakfast_inverted',
  'drink_inverted',
  'fitness_inverted',
] as const;

export const HPIconNames = ['hex', 'hex_inverted'] as const;

export const OLIconNames = ['arrow'] as const;

export const EYIconSetNames = new Set([...EYIconNames]);

export const ESIconSetNames = new Set([...ESIconNames]);

export const HPIconSetNames = new Set([...HPIconNames]);

export const OLIconSetNames = new Set([...OLIconNames]);
